import PropTypes from 'prop-types';
import { creatorType } from '~/types/creator';

export const creatorInsightsType = PropTypes.shape({
  id: PropTypes.string,
  ages: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    }),
  ),
  gendersPerAge: PropTypes.arrayOf(
    PropTypes.shape({
      values: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.number,
          label: PropTypes.string,
        }),
      ),
      label: PropTypes.string,
    }),
  ),
  genders: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.number, label: PropTypes.string }),
  ),
  cities: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.number, label: PropTypes.string }),
  ),
  countries: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.number, label: PropTypes.string }),
  ),
  creator: creatorType,
});
